exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Divider {\n  width: 100%;\n  height: 1px;\n  overflow: hidden;\n  background: #e1e7eb;\n  margin: 8px auto;\n  max-width: 40px;\n  clear: both; }\n", ""]);

// exports
